import { Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

import bentoBoxCardFields from 'organisms/Cards/BentoBoxCard/config';

const bentoBoxCardDeckFields = [
  ...moleculeHeadingFields,
  {
    name: 'cards',
    type: 'list',
    subFields: bentoBoxCardFields,
    helperText: 'Add up to 6 cards. Each card contains an image, title, description, and optional button.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      if (options.get('cards').length > 6) {
        options.set('cards', options.get('cards').slice(0, 6));
        alert('Maximum card count is 6. Removing excess cards.');
      }
    },
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const bentoBoxCardDeckConfig = {
  name: 'BentoBoxCardDeck',
  inputs: bentoBoxCardDeckFields,
};

export type BentoBoxCardDeckConfigProps = GenerateBuilder<typeof bentoBoxCardDeckFields>;

export default bentoBoxCardDeckConfig;
